module.exports = __webpack_public_path__ + "static/media/ups.d5c05b9d.png";